import React, { useState, useEffect, useContext } from "react";
import Footer from "../layout/Footer";
import { Link, useHistory } from "react-router-dom";
import { makeRequest } from "../../utils/request";
import { trackPageView } from "../../utils/adobeAnalytics";
import AppContext from "../AppContext";
import { sanitizeFormInput } from "../../utils/helper";
import { pushDatatoAdobeLayer } from '../../analytics/pmiAdobeLog';

const GoodbyePage = (isAuthenticated) => {

  // Adobe Analytics
  const { isFirstRender, setIsFirstRender } = useContext(AppContext);
  useEffect(() => {
    if (!isFirstRender) {
      trackPageView({ eVar4: "goodbye page" });
    } else {
      setIsFirstRender(false);
    }

  }, []);
  useEffect(() => {
    pushDatatoAdobeLayer({ status: isAuthenticated })
  }, [isAuthenticated]);
  // end Adobe Analytics

  const [fields, setFields] = useState({
    feedback: "",
  });
  const [loading, setLoading] = useState(false);
  const history = useHistory();

  const submit = async (e) => {
    e.preventDefault();

    try {
      const sanitizeValue = sanitizeFormInput(fields.feedback)
      if (!sanitizeValue) return;
      setLoading(true);
      await makeRequest("post", "/api/feedback", {
        feedback: JSON.stringify({ message: sanitizeValue, mood: "" }),
      });
      history.push("/account?message=feedback");
    } catch (e) {
      console.log(e);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex flex-col">
      <div className="container mx-auto p-4" style={{ marginTop: "80px" }}>
        <h1 className="text-3xl mt-10">We're sorry to see you go!</h1>
        <div className="text-xl mt-3">
          Access to content will be available for the remainder of the current
          subscription period. To help us better serve our community, let us
          know what we can do to improve PMIstandards+
        </div>

        <form onSubmit={submit}>
          <div>
            <textarea
              value={fields.feedback}
              onChange={(e) =>
                setFields({ ...fields, feedback: e.target.value })
              }
              name="feedback"
              id="feedback"
              cols="30"
              rows="10"
              disabled={loading}
              className="bg-white py-10 px-5 text-gray-800 w-full mt-5"
              placeholder="Type your feedback"
            />
          </div>

          <div className="mt-5 flex items-center">
            <button
              type="submit"
              disabled={loading}
              className="py-4 px-20 bg-orange-500 text-white hover:bg-gray-800"
            >
              {loading && <i className="fas fa-spin fa-spinner mr-3" />}
              SUBMIT
            </button>
            <Link
              to={"/account"}
              className="ml-8 text-gray-600 hover:text-gray-800"
            >
              Skip
            </Link>
          </div>
        </form>
      </div>

      <Footer />
    </div>
  );
};

export default GoodbyePage;
